import { render, staticRenderFns } from "./CoozzyDeleteIcon.vue?vue&type=template&id=a10bba96&scoped=true"
import script from "./CoozzyDeleteIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyDeleteIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyDeleteIcon.vue?vue&type=style&index=0&id=a10bba96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10bba96",
  null
  
)

export default component.exports